import { forwardRef } from 'react'
import PropTypes from 'prop-types'

const Input = forwardRef(
  (
    {
      wrapperClassName,
      className,
      leftAddon,
      rightAddon,
      rightAddonClick,
      rightAddonAriaLabel,
      type,
      ...props
    },
    ref = null
  ) => {
    return (
      <div className={`${wrapperClassName} relative`}>
        {leftAddon ? (
          <span className="absolute h-full w-[36px] px-[14px] flex items-center">{leftAddon}</span>
        ) : null}
        <input
          className={`placeholder:text-[#F6744388] border !border-primary-450 rounded-lg block ${leftAddon ? 'pl-[36px]' : ''} ${rightAddon ? 'pr-[36px]' : ''} py-[10px] px-[14px] ${className} outline-none w-full`}
          ref={ref}
          type={type}
          {...props}
        />
        {rightAddon ? (
          <button
            type="button"
            className="absolute h-full w-[36px] flex items-center justify-center right-0 top-0 cursor-pointer"
            onClick={rightAddonClick}
            aria-label={rightAddonAriaLabel}
          >
            {rightAddon}
          </button>
        ) : null}
      </div>
    )
  }
)

Input.defaultProps = {
  type: 'text',
  rightAddonClick: () => void 0,
  rightAddonAriaLabel: '',
}
Input.propTypes = {
  leftAddon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rightAddon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rightAddonClick: PropTypes.func,
  rightAddonAriaLabel: PropTypes.string,
}
export default Input
